export default "__VITE_ASSET__CKQCIlg7__"